import React from 'react';
import Bodentemperatur from '../components/Bodentemperatur';
import './home.css'; // gleiche Styles wie bei Home verwenden

function BodentemperaturMuerzzuschlag() {
  return (
    <div
      className="home-container"
      role="main"
      aria-labelledby="bodentemperatur-muerzzuschlag-heading"
    >
      <div className="home-diagramm">
        <div className="wetter-container">
          <h1 id="bodentemperatur-muerzzuschlag-heading">BODENTEMPERATUR</h1>
        </div>

        <Bodentemperatur ort="muerzzuschlag" />
      </div>
    </div>
  );
}

export default BodentemperaturMuerzzuschlag;
